// Copyright 2025 Diffblue Limited. All Rights Reserved.
// Unpublished proprietary source code.
// Use is governed by https://docs.diffblue.com/licenses/eula

/**
 * @returns The value of the hubspotutk cookie stored in browser.
 * If not set, returns an empty string.
 */
export function findHubspotutkCookie() {
  const hubspotCookieFetch = document.cookie.match("hubspotutk=.*?;");
  const hubspotCookieVal = hubspotCookieFetch?.at(0)?.split("=")?.at(1)?.replace(";", "").trim();
  return hubspotCookieVal ?? "";
}
